import React, { Component } from 'react';
import styled from "styled-components";


const StyledIntro = styled.section`
  background-color: var(--black);
  color: white;
  min-height: 100vh;
  padding-bottom: 15vh;

  h1{
    padding-top: 25vh;
    font-size: 8rem;
  }

  p{
    font-size: 2rem;
    line-height: 1.5;
    padding-bottom: 10vh;
  }

  input{
    width: 25vw;
    min-width: 250px;
    height: 3rem;
    border: none;
    margin: 5px;
    padding: 5px 10px;
  }

  button{
    font-weight: 700;
    height: 3rem;
    border: none;
    width: 8vw;
    min-width: 90px;
    margin: 5px;
    background-color: white;
  }

  button:hover{
    background-color: var(--yellow);
  }

  @media(max-width:800px){
    h1{
      font-size: 6rem;
    }
    p{
      font-size: 1.5rem;
    }
  }
  @media(max-width:460px){
    h1{
      font-size: 4rem;
    }
    p{
      font-size: 1.2rem;
    }
    form{
      display: flex;
      flex-direction: column;
    }
    input, button{
      width: 90%;
    }
  }
`

class Form extends Component {
  constructor() {
    super();
    this.state = {
      userInput: ""
    }
  }

  handleUinput = (event) => {
    this.setState({
      userInput: event.target.value
    })
  }


  render() {
    return (
      <StyledIntro className="searchIntro" id="searchIntro">
        <div className="wrapper">
        <h1>The Shoppies</h1>
        <p>Movie awards for entrepreneurs. Search the movie database and nominate your five favourite films for the 2021 Shoppies.</p>
        <form action="" onSubmit={(e) => {
          this.props.loadInput(e, this.state.userInput)
          this.props.showResults()
          this.setState({
            userInput: "",
          })
        }}>
          <label htmlFor="searchMovies" className="sr-only">Search Movies</label>
          <input
            type="text"
            id="searchMovies"
            value={this.state.userInput}
            onChange={this.handleUinput}
            placeholder="ex: The Intern"></input>
          <button type="submit">Search</button>
        </form>
        </div>
      </StyledIntro>

    );
  }
}



export default Form;